export const CHECKS = 'CHECKS';
export const DOMAIN = 'DOMAIN';
export const DOMAIN_LOCKED = `${DOMAIN}_LOCKED`;
export const COUNTRY_LOCKED = 'COUNTRY_LOCKED';
export const INCOMPATIBLE_VIDEO = 'INCOMPATIBLE_VIDEO';
export const VIDEO_VERSION = 'VIDEO_VERSION';
